import React from 'react';
import { RadioListOneColumn } from '../ui/RadioListOneColumn';
import { PrimaryButtonGreen } from '../ui/Buttons';
import { useSticker } from '../../context/StickerContext';
import { useToast } from '../ui/Toast';
export function SizePanel() {
  const {
    size,
    setSize,
    customWidth,
    setCustomWidth,
    customHeight,
    setCustomHeight
  } = useSticker();
  const {
    addToast
  } = useToast();
  const sizeOptions = ['1 x 1 inch', '2 x 2 inch', '3 x 3 inch', '4 x 4 inch', '5 x 5 inch', '6 x 6 inch', '7 x 7 inch', '8 x 8 inch', '9 x 9 inch', '10 x 10 inch', 'Custom size'];
  const handleContinue = () => {
    addToast('Size updated');
  };
  return <div className="h-full flex flex-col" data-id="element-134">
      <div className="p-4 border-b border-gray-100" data-id="element-135">
        <h2 className="font-semibold text-gray-900" data-id="element-136">Size of sticker</h2>
      </div>

      <div className="p-4 space-y-6 overflow-y-auto flex-1" data-id="element-137">
        <RadioListOneColumn name="editor_size" options={sizeOptions} value={size} onChange={setSize} data-id="element-138" />

        <div className="space-y-4" data-id="element-139">
          <div data-id="element-140">
            <label className="text-sm font-medium text-gray-700 block mb-1" data-id="element-141">
              Product width:
            </label>
            <input type="number" value={customWidth} onChange={e => setCustomWidth(Number(e.target.value))} className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:ring-2 focus:ring-violet-500 outline-none" data-id="element-142" />
            <p className="text-xs text-gray-400 mt-1" data-id="element-143">
              The range of values is 1 to 10 inch
            </p>
          </div>

          <div data-id="element-144">
            <label className="text-sm font-medium text-gray-700 block mb-1" data-id="element-145">
              Product height:
            </label>
            <input type="number" value={customHeight} onChange={e => setCustomHeight(Number(e.target.value))} className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:ring-2 focus:ring-violet-500 outline-none" data-id="element-146" />
            <p className="text-xs text-gray-400 mt-1" data-id="element-147">
              The range of values is 1 to 10 inch
            </p>
          </div>
        </div>
      </div>

      <div className="p-4 border-t border-gray-100" data-id="element-148">
        <PrimaryButtonGreen className="w-full" onClick={handleContinue} data-id="element-149">
          Continue
        </PrimaryButtonGreen>
      </div>
    </div>;
}